if (!customElements.get('mattress-size-guide')) {
  customElements.define(
    'mattress-size-guide',
    class MattressSizeGuide extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-size-guide-dialog]');
        this.querySelector('[data-size-guide-open]')?.addEventListener('click', () => this.dialog?.showModal());
        this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    }
  );
}
